<template>
  <div class="chart-container" style="position: relative;" :style="`width: ${size.width}; height: ${size.height};`">
    <canvas :id="uuid" :width="size.width" :height="size.height" />
  </div>
</template>

<script>

import { Chart } from "chart.js/auto";
import { Colorize, palette } from "@/libs/colorizer";
import ChartDataLabels from "chartjs-plugin-datalabels";
import moment from "moment";

export default {
  name: "70e72664-ddb0-11ed-8761-c85acf022408",
  mounted() {
    this.canvas = document.getElementById(this.uuid).getContext('2d')
    this.make_chart()
  },
  props: ['chart', 'size', 'title', 'uuid'],
  computed: {
    palette() {
      return palette
    },
    report_data() {
      return this.chart.report_data
    }
  },
  watch: {
    report_data() {
      this.update_chart()
    }
  },
  data() {
    return {
      canvas: null,
      graph: null,
      objecto: null,
      sys_list: [],
      datasets: [],
      month_list: [],
      monthz: [],
      months: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь'],
      monthx: [],
    }
  },
  methods: {
    Colorize,
    make_chart: function () {
      if (this.canvas) {
        this.update_data()
        let months = this.month_list
        this.graph = new Chart(this.canvas, {
          type: 'bar',
          plugins: [ ChartDataLabels ],
          data: {
            labels: this.monthz,
            datasets: this.datasets,
          },
          options: {
            plugins: {
              datalabels: {
                color: function (value) {
                  return Colorize(value.dataset.backgroundColor)
                },
                anchor: 'center',
                clamp: true,
                formatter: function (value) {
                  if (value > 0) return Math.ceil(value)
                  return null
                }
              },
              legend: {
                display: true
              },
              tooltip: {
                callbacks: {
                  title: function (value) {
                    return 'Количество обращений за месяц ' + months[value[0].dataIndex];
                  }
                }
              }
            },
            scales: {
              x: {
                stacked: true,
                ticks: {
                  // Include a dollar sign in the ticks
                  callback: function(index) {
                    let m = ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
                    return m[months[index]];
                  }
                }
              },
              y: {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function (value) { if (Number.isInteger(value)) { return value } },
                  stepSize: 1
                },
                title: {
                  display: true,
                  text: 'Кол-во обращений'
                },
              }
            }
          }
        })
        this.graph.data.datasets.push()
      }
    },
    update_data: function () {
      this.datasets = []
      this.objecto = null
      this.sys_list = []
      this.datasets = []
      this.month_list = []
      this.monthz = []

      for (let line of this.report_data) {
        if (!this.month_list.includes(moment(line['Месяц']).format('MMMM'))) {
          this.month_list.push(moment(line['Месяц']).format('MMMM'))
          this.monthz.push({
            name: moment(line['Месяц']).format('MMMM'),
            systems: []
          })
        }
      }

      for (let line of this.report_data) {
        if (!this.sys_list.includes(line['СервисПРЕДСТАВЛЕНИЕ'])) {
          this.sys_list.push(line['СервисПРЕДСТАВЛЕНИЕ'])
        }
      }

      let datasets = []
      for (let system of this.sys_list) {
        datasets.push({
          label: system,
          data: (() => {
            let array = []
            this.month_list.map((month, index) => {
              array.push(this.get_count_by_sys_n_month(system, index))
            })
            return array
          })(),
          maxBarThickness: 800,
        })
      }

      this.datasets = datasets
      /*this.objecto = this.month_list
      let name_of_null = 'ОТСУТСТВУЕТ ПОДСИСТЕМА'
      for (let i = 0; i < this.chart.report_data.length;i ++) {
        if (!this.sys_list.includes(this.shorten_src(this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]))){
          if (this.shorten_src(this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]) !== '') {
            this.sys_list.push(this.shorten_src(this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]))
          } else {
            this.sys_list.push(name_of_null)
          }
        }
      }

      for (let i = 0; i < this.chart.report_data.length; i ++) {
        let element = (this.shorten_src(this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]) !== '') ? this.shorten_src(this.chart.report_data[i]["СервисПРЕДСТАВЛЕНИЕ"]) : name_of_null
        if (this.month_list.includes(new Date(this.chart.report_data[i]["Месяц"]).getMonth()) && this.sys_list.includes(element)) {
          this.monthz[this.month_list.indexOf(new Date(this.chart.report_data[i]["Месяц"]).getMonth())].systems.push({
            system_name: element,
            obrashens: this.chart.report_data[i]["Обращения"]
          })
        }
      }
      let data = []
      for (let i = 0; i < this.sys_list.length; i++) {
        let system_error_by_object = []
        for (let j = 0; j < this.monthz.length; j++) {
          system_error_by_object[j] = 0
        }
        data.push(system_error_by_object)
      }
      for (let i = 0; i < this.monthz.length; i++) {
        for (let j = 0; j < this.monthz[i].systems.length; j++) {
          data[this.sys_list.indexOf(this.monthz[i].systems[j].system_name)][i] = this.monthz[i].systems[j].obrashens
        }
      }
      for (let i = 0; i < this.sys_list.length; i++) {
        this.datasets.push(
            {
              label: this.sys_list[i],
              data: data[i],
              maxBarThickness: 800,
            }
        )
      }*/
    },
    update_chart: function () {
      this.update_data()
      this.graph.destroy()
      this.make_chart()
    },
    shorten_src: function (name) {
      return name.split(' - ')[0]
    },
    get_count_by_sys_n_month: function (system, month_index) {
      let docs = this.report_data.filter(doc => this.month_list.findIndex(el => el === moment(doc['Месяц']).format('MMMM')) === month_index && doc['СервисПРЕДСТАВЛЕНИЕ'] === system)

      let count = 0
      for (let doc of docs) {
        count += doc['Обращения']
      }
      return count
    }
  }
}
</script>
